import { formatReportNumber } from '../../../../../../features/formatters'
import { chartColors } from './styles'

export const getOptions = (legendContainerId, currencySymbol, hideXAxes = false) => ({
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    // Headcount axis (bottom)
    'x-headcount': {
      type: 'linear',
      position: 'bottom',
      stacked: false,
      ticks: {
        display: !hideXAxes,
        color: chartColors.headcount,
        font: {
          size: 12,
          weight: 400
        }
      },
      grid: {
        drawBorder: false,
        drawOnChartArea: !hideXAxes,
        color: 'rgba(18, 150, 134, 0.1)'
      },
      border: {
        display: !hideXAxes,
        color: chartColors.headcount
      },
      title: {
        display: false
      }
    },
    // Per-stakeholder impact axis (top)
    'x-per-stakeholder': {
      type: 'linear',
      position: 'top',
      stacked: false,
      ticks: {
        display: !hideXAxes,
        color: chartColors.perStakeholderImpact,
        font: {
          size: 12,
          weight: 400
        },
        callback: function (value) {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'm'
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'k'
          }
          return value
        }
      },
      grid: {
        drawBorder: false,
        drawOnChartArea: false,
        color: 'rgba(219, 142, 70, 0.1)'
      },
      border: {
        display: !hideXAxes,
        color: chartColors.perStakeholderImpact
      },
      title: {
        display: false
      }
    },
    // Y-axis (stakeholder labels)
    y: {
      stacked: false,
      ticks: {
        display: true,
        color: '#000',
        font: {
          size: 17,
          weight: 400
        }
      },
      grid: {
        display: false
      },
      border: {
        dash: [6, 6],
        display: true,
        color: '#000'
      }
    }
  },
  plugins: {
    legend: { display: false },
    datalabels: {
      display: true,
      formatter: value => formatReportNumber({ value, format: 'currency', currency: currencySymbol })
    },
    htmlLegend: {
      // ID of the container to put the legend in
      containerID: legendContainerId
    }
  }
})
